import * as React from "react";
import { forwardRef } from "react";
import { chakra, useStyleConfig } from "@chakra-ui/react";
export const SortVerticalDownIcon = forwardRef(({ baseline = false, ...props }, ref) => {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return React.createElement(chakra.svg, { __css: styles, xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ref: ref, ...props },
        React.createElement("path", { d: "M17 8.75a1 1 0 1 0-2 0v7.953l-1.517-1.633a1 1 0 1 0-1.466 1.36l3.248 3.498a1.195 1.195 0 0 0 .046.047.996.996 0 0 0 1.355.021.99.99 0 0 0 .067-.066l3.25-3.5a1 1 0 1 0-1.466-1.36L17 16.703V8.75Z" }),
        React.createElement("path", { d: "M8 3.75c.29 0 .551.124.734.32l3.249 3.5a1 1 0 1 1-1.466 1.36L9 7.297v7.953a1 1 0 1 1-2 0V7.297L5.483 8.93a1 1 0 0 1-1.466-1.36l3.247-3.497A.997.997 0 0 1 8 3.75Z", opacity: 0.5 }));
});
SortVerticalDownIcon.displayName = "SortVerticalDownIcon";
